
const cartForm = document.querySelector("cart-form");
const productForm = document.querySelector("product-form");

handleCheckoutButton();

if(cartForm) {
  cartForm.addEventListener('cart-updated', () => {
    console.log("cart updated")
    handleCheckoutButton();
  });
}

if(productForm) {
  productForm.addEventListener('add-to-cart', () => {
    handleCheckoutButton();
  })
}


function handleCheckoutButton() {
  let checkboxes = document.querySelectorAll('[data-required-policy]');
  const checkoutButton = document.querySelector('#CheckOut');

  if (!checkboxes.length || !checkoutButton) return;

  checkboxes = Array.from(checkboxes)

  function handleCheckoutButton() {
    const policiesChecked = checkboxes.every(checkbox => checkbox.checked);

    if (policiesChecked) checkoutButton.disabled = false;
    else checkoutButton.disabled = true
  }

  checkboxes.forEach(check => check.addEventListener('change', handleCheckoutButton));
}